/**
 * @module invalidatingThen
 * @purpose Await a mutation promise, invalidate the given list keys on success, then pass the result through.
 * @depends ListResourceKey from use-list-invalidation
 * @dependedOnBy use-collection-requests.ts, use-stall-mutations.ts
 *
 * @rules
 * - State: none -- pure async helper
 * - Errors: rejects propagate unchanged; invalidation only runs on resolve
 */

import type { ListResourceKey } from '../use-list-invalidation'

export function invalidatingThen<T>(
  promise: Promise<T>,
  invalidate: (keys: ListResourceKey[]) => void,
  keys: ListResourceKey[]
): Promise<T> {
  return promise.then((result) => {
    invalidate(keys)
    return result
  })
}
